import { writable } from "svelte/store";
export const svgWidth = writable(500);
export const svgHeight = writable(400);
export const svgCode = writable(0);
export const svgStrokeColor = writable("#A04DC7");
export const svgLinecap = writable("round");
export const svgStrokeOffset = writable(0);
export const svgStrokeDashArray = writable("25");
export const svgStrokeWidth = writable(5);
